import { render, staticRenderFns } from "./CarBrandModels.vue?vue&type=template&id=5b9dc38f&scoped=true"
import script from "./CarBrandModels.vue?vue&type=script&lang=js"
export * from "./CarBrandModels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9dc38f",
  null
  
)

export default component.exports